// The Assigned To x Stage table. One row per OWNER (by id, so two people who share a name stay two
// rows with their own counts and their own click-through link); the name is only the label.
export function buildOwnerStageMatrix(rows, stageRank) {
  const stages = Array.from(new Set(rows.map((r) => r.stage)))
    .sort((a, b) => stageRank(a) - stageRank(b) || a.localeCompare(b));
  const byOwner = new Map();
  const lookup = {};
  for (const r of rows) {
    const key = r.owner_id == null ? "unassigned" : String(r.owner_id);
    if (!byOwner.has(key)) {
      byOwner.set(key, { key, id: r.owner_id ?? null, name: r.owner, active: r.active, total: 0 });
    }
    byOwner.get(key).total += r.count;
    lookup[`${key}|${r.stage}`] = (lookup[`${key}|${r.stage}`] || 0) + r.count;
  }
  const owners = Array.from(byOwner.values()).sort((a, b) => b.total - a.total);
  const stageTotals = {};
  for (const s of stages) stageTotals[s] = owners.reduce((sum, o) => sum + (lookup[`${o.key}|${s}`] || 0), 0);
  const grandTotal = owners.reduce((sum, o) => sum + o.total, 0);
  return { stages, owners, lookup, stageTotals, grandTotal };
}
